export class KpiMaster {
    kpiId: number;
    displayText: string;
    descriptionText?: string;
    displayOrder: number;
    suffix?: string;
    isDefault: boolean;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    updatedBy: string;
    updatedOn: Date;
    kpiCount: string;
}
